import axios from 'axios';
import { API_BASE_URL, AUTH_STORAGE_KEY, PUBLIC_API_TOKEN } from '../config/adminConfig';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  let token = PUBLIC_API_TOKEN || null;

  try {
    const stored = sessionStorage.getItem(AUTH_STORAGE_KEY);
    if (stored) {
      const sessionToken = JSON.parse(stored)?.token;
      if (sessionToken) {
        token = sessionToken;
      }
    }
  } catch {
    // ignore malformed session
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});
